
<div id="skip-nav"></div>

<div class="dcf-d-flex dcf-flex-wrap dcf-ai-center dcf-wrapper dcf-pt-3 dcf-pb-3 dcf-bold dcf-txt-decor-none unl-font-sans unl-cream" style="background-color: #007197;">
  <span class="dcf-txt-xs">
    <span class="dcf-d-inline-block dcf-mt-2 dcf-mb-2 dcf-mr-4">
      TCAN will be conducting in-person return preparation in 2026. In addition, TCAN will have virtual site (remote preparation) and Facilitated Self Assistance (FSA) appointments available. You may schedule an appointment under the 'Need Assistance' tab.
    </span>
  </span>
</div>

<script> 
  $(function(){
    $("#skip-nav").load("https://unlcms.unl.edu/wdn/templates_5.1/includes/global/skip-nav.html"); 
  });
  </script> 
<!-- <app-announcement></app-announcement> -->

<app-header></app-header>

<main class="dcf-main" id="dcf-main" role="main" tabindex="-1">
<router-outlet></router-outlet>
</main>
<footer class="dcf-footer" id="dcf-footer" role="contentinfo">
  <app-footer></app-footer>
  <noscript>
    <div id="dcf-noscript">
      <p>Some parts of this site work best with JavaScript enabled.</p>
    </div>
  </noscript>
</footer>
<script src="/dist/index.js"></script>
